import React, { Component } from 'react';
import './styles.css';
import logo from '../img/logo.gif';

class Header extends Component{
    render(){
        return <header> 
                <div className="h-content">
                    <img src={logo} alt="logo-p" />
                    <h1> My App </h1>
                </div>
               </header>
        }
}

export default Header; 